var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    transform: "translate(-813 -208)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -282.5,
    y: -65.5,
    width: 825,
    height: 559,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -282.5,
    y: -65.5,
    width: 825,
    height: 559,
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: -813,
    y: -208,
    width: 1366,
    height: 768,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -813,
    y: -208,
    width: 1366,
    height: 768,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -52.5,
    y: -7.5,
    width: 87,
    height: 47,
    rx: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -52.5,
    y: -7.5,
    width: 87,
    height: 47,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -261,
    y: -30,
    width: 406,
    height: 434,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 44,
    height: 44,
    rx: 2,
    transform: "rotate(180 30 30)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "back-icon",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16L9.41 14.59L3.83 9L16 9L16 7L3.83 7L9.41 1.41L8 6.99382e-07L-6.99382e-07 8L8 16Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#back-icon)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 24,
    height: 24,
    transform: "rotate(180 20 20)",
    fill: "#1A2D38"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.5,
    width: 43,
    height: 43,
    rx: 1.5,
    transform: "rotate(180 29.5 29.5)",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -260.5,
    y: -29.5,
    width: 405,
    height: 433,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -812.5,
    y: -207.5,
    width: 1365,
    height: 767,
    stroke: "none"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -833,
    y: -233,
    width: 1406,
    height: 808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: -281,
    y: -45,
    width: 446,
    height: 474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: -16,
    y: -15,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white",
    transform: "translate(-813 -208)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.cb172207.svg";
export { ForwardRef as ReactComponent };